import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth-guard.service';
import { isManagerLike } from '../../guards/isManager-guard';
import { DocumentsResolver } from '../../store/documents/documents.resolver';
import { canActivateProjectsManagerGuard } from '../../guards/can-activate-projects-manager.guard';
import { CashFlowComponent } from './cash-flow/cash-flow.component';
import { TemplatesComponent } from './templates/templates.component';
import { DriveComponent } from './drive/drive.component';
import { WebappComponent } from './webapp.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { ContactsComponent } from '@app/pages/webapp/contacts/contacts.component';
import { canActivateProjectsSPGuard } from '@app/guards/can-activate-projects-sp.guard';
import { PROJECT_VIEWS } from '@app/framework/constants/view-project.constants';
import { redirectToManagerOrServiceProvider } from '@app/guards/redirect-to-mgr-or-sp';

export const webappRoutes: Routes = [
  {
    path: 'subscribe',
    canActivate: [AuthGuard],
    component: SubscribeComponent,
  },
  {
    path: '',
    component: WebappComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'projects/manager',
        loadComponent: () =>
          import('./rollups/manager/rollups.component').then((m) => m.RollupsComponent),
        canActivate: [canActivateProjectsManagerGuard],
      },
      {
        path: 'projects/service-provider',
        loadComponent: () =>
          import('./rollups/gcplus/rollups-sp.component').then((m) => m.RollupsSpComponent),
        canActivate: [canActivateProjectsSPGuard],
      },

      {
        path: 'projects/:id',
        redirectTo: 'projects/:id/' + PROJECT_VIEWS.DEFAULT,
        pathMatch: 'full',
      },
      {
        path: 'projects/:id/:view',
        loadComponent: () =>
          import('./projects/view-project/view-project.component').then(
            (m) => m.ViewProjectComponent,
          ),
        resolve: {
          documents: DocumentsResolver,
        },
      },
      {
        // this route just redirects based on role
        // to 'contractor/projects' or 'manager/projects'
        path: 'projects',
        canMatch: [redirectToManagerOrServiceProvider],
        pathMatch: 'full',
        children: [],
      },
      {
        path: 'contacts',
        component: ContactsComponent,
      },
      {
        path: 'documents',
        component: DriveComponent,
        resolve: {
          documents: DocumentsResolver,
        },
      },
      {
        path: 'documents/:uuid',
        component: DriveComponent,
        resolve: {
          documents: DocumentsResolver,
        },
      },
      {
        path: 'settings/templates',
        component: TemplatesComponent,
      },
      {
        path: 'settings/teams',
        loadComponent: () => import('./teams/teams.component').then((m) => m.TeamsComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('../webapp/settings/user-settings/user-settings.component').then(
            (m) => m.UserSettingsComponent,
          ),
      },
      {
        path: 'cashflow',
        component: CashFlowComponent,
      },
      {
        path: 'settings/properties',
        loadComponent: () =>
          import('./settings/properties/properties.component').then((m) => m.PropertiesComponent),
      },

      {
        path: 'activities',
        loadComponent: () =>
          import('./activities/activities/activities.component').then((m) => m.ActivitiesComponent),
        canActivate: [isManagerLike],
      },
      { path: '', redirectTo: 'activities', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(webappRoutes)],
  exports: [RouterModule],
})
export class WebappRoutingModule {}
